<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-5 h-96 overflow-auto">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">เพิ่มแก๊งค์ใหม่</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <!-- ฟอร์ม -->
            <form @submit.prevent="handleAddGang">
              <div class="space-y-4 mb-6">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อแก๊งค์</label>
                    <input
                      v-model="newGang.name"
                      type="text"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ระดับแก๊งค์</label>
                    <select
                      v-model.number="newGang.level"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                      <option value="" disabled>เลือกระดับ</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพแก๊งค์</label>
                    <input
                      v-model="newGang.img"
                      type="url"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/image.jpg"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">สถานที่แก๊งค์อาศัย</label>
                    <input
                      v-model="newGang.location"
                      type="text"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="เช่น ป่าช้า"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">จำนวนชาวบ้านขั้นต่ำเพื่อบุก</label>
                    <input
                      v-model.number="newGang.minVillagersToAttack"
                      type="number"
                      min="1"
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                  </div>
                </div>
                <!-- รายชื่อชาวบ้านในแก๊งค์ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">รายชื่อชาวบ้านในแก๊งค์</h4>
                  <div v-for="(member, index) in newGang.members" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-10">
                      <input
                        v-model="newGang.members[index]"
                        type="text"
                        placeholder="ชื่อชาวบ้าน"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button
                        v-if="index > 0"
                        @click="removeMember(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบชาวบ้าน"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button
                      @click="addMember"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มชาวบ้าน
                    </button>
                  </div>
                </div>
                <!-- ไอเทมที่ดรอปเมื่อชนะ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ไอเทมที่ดรอปเมื่อชนะ (พร้อมโอกาส 0-10000, 1000=10%)</h4>
                  <div v-for="(drop, index) in newGang.dropItems" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-5">
                      <input
                        v-model="newGang.dropItems[index].itemName"
                        type="text"
                        placeholder="ชื่อไอเทม"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-5">
                      <input
                        v-model.number="newGang.dropItems[index].chance"
                        type="number"
                        min="0"
                        max="10000"
                        placeholder="โอกาส (0-10000)"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button
                        v-if="index > 0"
                        @click="removeDropItem(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบไอเทม"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button
                      @click="addDropItem"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มไอเทม
                    </button>
                  </div>
                </div>
                <!-- ไอเทมดรอปครั้งแรก -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ไอเทมที่จะดรอปเมื่อชนะครั้งแรก</h4>
                  <div v-for="(firstDrop, index) in newGang.firstWinItems" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-5">
                      <input
                        v-model="newGang.firstWinItems[index].itemName"
                        type="text"
                        placeholder="ชื่อไอเทม"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-5">
                      <input
                        v-model.number="newGang.firstWinItems[index].quantity"
                        type="number"
                        min="0"
                        placeholder="จำนวน (optional)"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button
                        v-if="index > 0"
                        @click="removeFirstWinItem(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบไอเทม"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button
                      @click="addFirstWinItem"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มไอเทม
                    </button>
                  </div>
                </div>
                <!-- แก๊งค์ที่ต้องชนะก่อน -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">แก๊งค์ที่ต้องชนะก่อน (เลือกหลาย)</h4>
                  <div v-for="(prereq, index) in newGang.prerequisites" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-10">
                      <input
                        v-model="newGang.prerequisites[index]"
                        type="text"
                        placeholder="ชื่อแก๊งค์ที่ต้องชนะก่อน"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button
                        v-if="index > 0"
                        @click="removePrerequisite(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบแก๊งค์"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button
                      @click="addPrerequisite"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มแก๊งค์
                    </button>
                  </div>
                </div>
              </div>
              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  เพิ่มแก๊งค์
                </button>
                <button
                  @click="$emit('cancelModal')"
                  type="button"
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from 'vue';
import { projectFirestore } from '@/firebase/config';
export default {
  emits: ['cancelModal', 'gangAdded'],
  setup(props, { emit }) {
    const newGang = ref({
      name: '',
      img: 'https://example.com/default-gang.png',
      members: [''],
      dropItems: [{ itemName: '', chance: 0 }],
      firstWinItems: [{ itemName: '', quantity: 0 }],
      minVillagersToAttack: 1,
      level: 1,
      prerequisites: [''],
      location: '',
      createdAt: new Date()
    });
    // Members
    const addMember = () => {
      newGang.value.members.push('');
    };
    const removeMember = (index) => {
      if (newGang.value.members.length > 1) {
        newGang.value.members.splice(index, 1);
      }
    };
    // Drop Items
    const addDropItem = () => {
      newGang.value.dropItems.push({ itemName: '', chance: 0 });
    };
    const removeDropItem = (index) => {
      if (newGang.value.dropItems.length > 1) {
        newGang.value.dropItems.splice(index, 1);
      }
    };
    // First Win Items
    const addFirstWinItem = () => {
      newGang.value.firstWinItems.push({ itemName: '', quantity: 0 });
    };
    const removeFirstWinItem = (index) => {
      if (newGang.value.firstWinItems.length > 1) {
        newGang.value.firstWinItems.splice(index, 1);
      }
    };
    // Prerequisites
    const addPrerequisite = () => {
      newGang.value.prerequisites.push('');
    };
    const removePrerequisite = (index) => {
      if (newGang.value.prerequisites.length > 1) {
        newGang.value.prerequisites.splice(index, 1);
      }
    };
    // Handle adding new gang
    const handleAddGang = async () => {
      try {
        const gangName = newGang.value.name.trim();
        if (!gangName || /[/\.#$$$ $$]/.test(gangName)) {
          alert('ชื่อแก๊งค์ไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }
        // ตรวจสอบว่ามีชื่อแก๊งค์ซ้ำหรือไม่
        const docRef = projectFirestore.collection('gameGanks').doc(gangName);
        const docSnap = await docRef.get();
        if (docSnap.exists) {
          alert('ชื่อแก๊งค์นี้มีอยู่แล้ว ไม่สามารถสร้างซ้ำได้');
          return;
        }
        // Filter valid arrays
        const filteredMembers = newGang.value.members.filter(member => member.trim());
        const filteredDropItems = newGang.value.dropItems.filter(drop => drop.itemName.trim() && drop.chance >= 0);
        const filteredFirstWinItems = newGang.value.firstWinItems.filter(firstDrop => firstDrop.itemName.trim());
        const filteredPrerequisites = newGang.value.prerequisites.filter(prereq => prereq.trim());
        const newGangData = {
          name: gangName,
          img: newGang.value.img,
          members: filteredMembers,
          dropItems: filteredDropItems,
          firstWinItems: filteredFirstWinItems.map(item => ({ ...item, quantity: item.quantity || 1 })),
          minVillagersToAttack: newGang.value.minVillagersToAttack,
          level: Number(newGang.value.level),
          prerequisites: filteredPrerequisites,
          location: newGang.value.location,
          createdAt: new Date()
        };
        // Add gang to gameGanks collection
        await projectFirestore.collection('gameGanks').doc(gangName).set(newGangData);
        console.log('Gang added successfully:', gangName);
        emit('gangAdded');
        emit('cancelModal');
      } catch (error) {
        console.error('Error adding gang:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };
    return {
      newGang,
      handleAddGang,
      addMember,
      removeMember,
      addDropItem,
      removeDropItem,
      addFirstWinItem,
      removeFirstWinItem,
      addPrerequisite,
      removePrerequisite
    };
  }
};
</script>
<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>